const HTML_TAG_PATTERN = /<[a-z][\s\S]*>/i;

export const hasHtmlTags = (value: string): boolean => HTML_TAG_PATTERN.test(value);

export const escapeHtml = (text: string): string =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

export const plainTextToHtml = (text: string): string => {
  if (!text.trim()) return '';
  return `<p>${escapeHtml(text).replace(/\n/g, '<br>')}</p>`;
};

export const valueToEditorContent = (value: string): string => {
  if (!value.trim()) return '';
  if (hasHtmlTags(value)) return value;
  return plainTextToHtml(value);
};

export const isRichTextEmpty = (html: string): boolean => {
  if (!html.trim()) return true;

  const stripped = html
    .replace(/<br\s*\/?>/gi, '')
    .replace(/<p>\s*<\/p>/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();

  return stripped.length === 0;
};

export const normalizeRichTextHtml = (html: string): string => {
  if (isRichTextEmpty(html)) return '';
  return html.trim();
};
